import {on, find, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-toggle-accessory', function (element) {
        on('change', function () {
            //find all subitems and hide tem
            let allOptions = findAllIn('option', this);
            allOptions.forEach((option) => {
                let component = option.getAttribute('value');
                let element = find('#subitem-' + component);

                if (element) {
                    let selectInput = findAllIn('select', element);
                    selectInput.forEach((select) => {
                        select.setAttribute('disabled', '');
                    });
                    element.setAttribute('hidden', '');
                }
            })


            //find active option of selected element and show subitem
            let activeOption = element.value;
            let activeElement = find('#subitem-' + activeOption);
            if (activeElement) {
                let activeSelectInput = findAllIn('select', activeElement);
                activeSelectInput.forEach((select) => {
                    select.removeAttribute('disabled');
                });
                activeElement.removeAttribute('hidden');
            }
        }, element);
    });
}